/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column, Row, SubtitleSection } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomButton from "components/CustomButton/CustomButton";
import Preloader from "components/Preloader/Preloader";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion
//#region Icons
import DisketIcon from "icons/DisketIcon";
//#endregion
//#region Services
import { requestRegisterAdminReservation } from "services/resources/library/aboutLibraryResources";
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { ERROR_TEXTS, INITIAL_ERRORS, INITIAL_FORM } from "./constants";
import { getMinutesOfToday } from "components/CustomTimePicker/utils";
import { getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
//#endregion

const FormManualReservationData = ({
    showUpdateDialog,
    resourceType,
    resourceId, date,
    reloadData
}) => {
    //#region Extra
    //#endregion
    //#region States
    const [form, setForm] = useState({ ...INITIAL_FORM });
    const [errors, setErrors] = useState({ ...INITIAL_ERRORS });
    const [loadingRequest, setLoadingRequest] = useState({
        hidden: true,
        message: "Cargando..."
    });
    //#endregion
    //#region Effects
    useEffect(() => {
        // Setteando fecha de hoy
        setForm({
            ...form,
            date
        });
    }, []);
    //#endregion
    //#region Functions
    const changeField = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
        if (!["timeStart", "timeEnd"].includes(field)) return;
        setErrors(prev => ({
            ...prev,
            schedule: {
                ...prev.schedule,
                value: false
            }
        }));
    }
    const changeName = value => {
        changeField("name", value);
    }
    const changeDetails = value => {
        changeField("details", value);
    }
    const changeTimeStart = value => {
        changeField("timeStart", value);
    }
    const changeTimeEnd = value => {
        changeField("timeEnd", value);
    }
    const areIncompleteFields = () => {
        const { 
            name,
            details,
            timeStart,
            timeEnd
        } = form;
        return !name ||
            !details ||
            timeStart === -1 ||
            timeEnd === -1;
    }
    const fillErrorSchedule = text => {
        setErrors(prev => ({
            ...prev,
            schedule: {
                value: true,
                text
            }
        }))
    }
    const isValidForm = () => {
        const { date, timeStart, timeEnd } = form;
        if (timeStart >= timeEnd) {
            fillErrorSchedule(ERROR_TEXTS.START_DATE_IS_GREATER_THAN_END_DATE);
            return false;
        }
        const now = getMinutesOfToday();
        const today = getTodayWithoutHourInMillis();
        if (date < today || (date === today && timeStart < now)) {
            fillErrorSchedule(ERROR_TEXTS.PAST_SCHEDULE);
            return false;
        }
        return true;
    }
    const registerAdminReservation = async () => {
        if (!isValidForm()) return;
        const loadingRequestObj = {
            hidden: false,
            message: "Registrando reserva..."
        };
        setLoadingRequest({ ...loadingRequestObj });
        const success = await requestRegisterAdminReservation({
            ...form,
            resourceId
        });
        loadingRequestObj.hidden = true;
        setLoadingRequest({ ...loadingRequestObj });
        if (success) {
            reloadData();
            return;
        }
        fillErrorSchedule(ERROR_TEXTS.CROSS_SCHEDULES);
    }
    //#endregion
    return (
        <>
        <Container>
            <SubtitleSection align="center">Registro de Reserva Administrativa</SubtitleSection>
            <Column gap="12px">
                <CustomTextInput 
                    label="Nombre de la reserva"
                    placeholder="Escribe el nombre de la reserva"
                    value={form.name}
                    onChange={changeName}
                    maxLength={30}
                    width="100%"/>
                <CustomTextArea 
                    label="Detalles"
                    placeholder="Escribe los detalles de la reserva"
                    value={form.details}
                    showCharCounter={false}
                    onChange={changeDetails}
                    maxLength={200}
                    height="50px"/>
                <CustomDatePicker 
                    label="Fecha"
                    value={form.date}
                    onChange={() => {}}
                    width="100%"
                    disabled/>
                <Row>
                    <CustomTime 
                        label="Desde"
                        value={form.timeStart}
                        onChange={changeTimeStart}/>
                    <CustomTime 
                        label="Hasta"
                        value={form.timeEnd}
                        onChange={changeTimeEnd}/>
                </Row>
                <ErrorMessage error={errors.schedule.value} text={errors.schedule.text}/>
                <CustomSelect 
                    label="Recurso"
                    value={resourceType.value}
                    optionsProps={getOptionsToCustomSelect(resourceType.types, { id: "id", text: "name" })}
                    onChange={() => {}}
                    defaultOptionText="Elige un Recurso"
                    width={{
                        container: "100%",
                        containerSelect: "100%"
                    }}
                    disabled/>
                <CustomButton 
                    icon={<DisketIcon/>}
                    text="Registrar"
                    width="100%"
                    onClick={registerAdminReservation}
                    disabled={areIncompleteFields()}/>
            </Column>
        </Container>
        {showUpdateDialog &&
        <Preloader {...loadingRequest}/>}
        </>
    );
}

export default FormManualReservationData;